import React, {
  useEffect,
  useState,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ProjectRegisterPage from '../ProjectRegister/ProjectRegisterPage';
import WizardForm from '../../components/WizardForm';
import Footer from '../../Layouts/Layout/Footer';
import { ContextFormData, ContextForm } from '../../utils/projectRegistration';
import Layout from '../../Layouts/Layout';
import storage from '../../utils/storage';
import RequestModal from '../../components/RequestModal';
import { handleResponseStatus, sendRequest } from '../../utils/api-request';
import getConfig from '../../config';

const { backendApi } = getConfig();

const LaunchProject = () => {
  const translate = useIntl();
  const [formData, setFormData] = useState(ContextFormData);
  const [requestError, setRequestError] = useState(false);
  const [requestErrorMessage, setRequestErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(false);

  const postIsInterested = async (body) => {
    const JSONBody = JSON.stringify(body);
    const { statusCode } = await sendRequest(`${backendApi}/api/dashboard/save-is-interest-carbon`, 'POST', JSONBody, true);
    return handleResponseStatus(
      statusCode,
      () => true,
      () => false,
    );
  };

  const handleProjectCreated = async (projectId) => {
    try {
      const interestedInCarbon = storage.get('isInterest');
      if (!interestedInCarbon) {
        setRequestError(false);
        setShowModal(true);
        return;
      }
      const done = await postIsInterested({
        ...interestedInCarbon,
        project_id: projectId,
      });
      setRequestError(!done);
      setShowModal(true);
    } catch (e) {
      setRequestError(true);
      setShowModal(true);
    } finally {
      storage.del('isInterest');
    }
  };

  useEffect(() => () => storage.del('isInterest'), []);

  return (
    <>
      {showModal && (
        <RequestModal
          error={requestError}
          handleClose={() => {
            setShowModal(false);
            setRequestErrorMessage('');
          }}
          title={requestError ? translate.formatMessage({ id: 'modal.title.oops' }) : translate.formatMessage({ id: 'modal.title.success' })}
          description={requestErrorMessage || (requestError ? (
            <FormattedMessage
              id="modal.description.somethingGoesWrong"
              values={{
                link: (...chunks) => <a href="mailto:support@openforestprotocol.org" className="text-anchor">{chunks}</a>,
              }}
            />
          ) : (
            <FormattedMessage
              id="wizardForm.popup.regNewProjectSuccess"
              values={{
                span: (...chunks) => <span className="regNewProjectSuccess">{chunks}</span>,
              }}
            />
          ))}
        />
      )}
      <ContextForm.Provider value={{ formData, setFormData }}>
        {formData.isProjectRegisterForm ? (
          <Layout>
            <ProjectRegisterPage />
          </Layout>
        ) : (
          <div className="wizardFormWrapper">
            <WizardForm
              setRequestError={setRequestError}
              setRequestErrorMessage={setRequestErrorMessage}
              setShowModal={setShowModal}
              onProjectCreated={handleProjectCreated}
            />
            <Footer />
          </div>
        )}
      </ContextForm.Provider>
    </>
  );
};

export default LaunchProject;
